import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import * as _ from "lodash-es";

import { ModalComponent } from '../../../../core/config/core.modal-helpers';
import { BoardService } from '../board.service';
import { BoardRest } from '../board.rest';
import { GfTranslateService } from '../../../services/core.translate.service';
import { TrackerRest } from '../../../../plugins/tracker/services/tracker.rest';
import { UiService } from '../../../services/core.ui.service';
@Component({
    selector: 'board-add-edit-modal',
    template: require('./board.add.edit.component.html')
})
export class BoardAddEditModalComponent extends ModalComponent implements OnInit {
    protected footerMessage = '';

    @Input() project: any = null;
    @Input() board: any = null;
    @Input() queries: any = null;
    @Input() sprints: any = null;
    @Input() releases: any = null;

    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected selectedDataSource: any = null;
    protected selectedDataSourceLabel = 'Data Sources';
    protected options: any = null;

    protected errors: any = {};
    protected fields: any = [];
    private sections: any;

    constructor(
        private trackerRest: TrackerRest,
        protected boardService: BoardService,
        private boardRest: BoardRest,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
    ) { super(); }

    ngOnInit(): void {

        //ToDo: locking this feature down to only queries for this release
        /*
        this.options = [
            {id: 'queries', name: 'Tracker Queries', section: 'query', children: mapQueriesToDrillDownOptions(this.queries)},
            {id: 'sprints', name: 'Sprints',  section: 'sprint', children: mapSprintsToDrillDownOptions(this.sprints)},
            {id: 'releases', name: 'Releases',  section: 'release', children: mapReleasesToDrillDownOptions(this.releases)}
        ];*/
        //ToDo: remove this with the block above is re-enabled
        this.options =
            [{
                id: 'queries',
                name: 'Trackers',
                section: 'query',
                children: this.mapQueriesToDrillDownOptions(this.queries)
                    .map((item: any) => {
                        item.id = item.id.toString();
                        return item;
                    })
            }];

        this.errors = {};
        this.fields = [];

        this.sections = this.boardService.getSections();

        let selectedStack: any = this.findInTree(
            this.board?.section,
            this.board?.refId,
            this.options
        );
        const selectedItem = _.last(selectedStack);
        if (!_.isEmpty(selectedItem)) {
            this.selectedDataSource = selectedItem;
            this.selectedDataSourceLabel = this.getSelectedDataSourceLabel(selectedStack);
        };
        this.loadFields(_.get(this.board, 'config.query.tracker', 0));
    };

    setShared(value) {
        this.board.isShared = (value == 'Y') ? 'Y' : 'N';
    };

    setCollapseEmpty(field, value) {
        _.set(this.board, 'config.collapseEmpty.' + field, value);
    };

    setSelectedDataSource(item: any) {
        if (!item) return;

        if (_.has(item, 'section')) {
            this.board.section = item.section;
        }

        if (!_.has(item, 'children')) {     // It's a leaf, contains the actual datasource object
            this.board.refId = item.id;

            let selectedStack: any = this.findInTree(
                this.board?.section,
                this.board?.refId,
                this.options
            );

            if (selectedStack.length > 0) {
                const selectedItem = _.last(selectedStack);

                this.selectedDataSource = selectedItem;
                switch (this.board.section) {
                    case 'query':
                        this.setSelectedQuery(selectedItem);
                        break;

                    case 'sprint':
                        this.setSelectedSprint(selectedItem);
                        break;

                    case 'release':
                        this.setSelectedRelease(selectedItem);
                        break;
                }
                this.selectedDataSourceLabel = this.getSelectedDataSourceLabel(selectedStack);
            }
        }        
    };

    setSelectedColumnSource(field: any) {
        this.setSelected(field, 'columnSource');
    };

    getSectionsTitle() {
        return (this.board.section) ? this.board.section : 'Sections';
    };

    getQueriesTitle() {
        return _.get(this.board.config, 'query.queryName', 'Queries');
    };

    getColumnsTitle() {
        return _.get(this.board, 'config.columnSource.description', 'Select Source for Columns');
    };

    getRowsTitle() {
        return _.get(this.board, 'config.rowSource.description', 'Select Source for Rows');
    };

    /** Fields not yet used as a column or row source, for the source dropdowns. */
    getUnselectedFields() {
        return _.sortBy(_.filter(this.fields, { selected: false }), ['description']);
    };

    setSelectedRowSource(field: any) {
        this.setSelected(field, 'rowSource');
    };

    submitBoard() {
        this.errors = {};

        let params = _.cloneDeep(this.board);
        params.project = _.isObject(this.board.project) ? this.board.project.id : this.board.project;
        params.user = _.isObject(this.board.user) ? this.board.user.id : this.board.user;

        return this.boardRest.postBoard(_.get(this.board, 'id', 0), params)
            .then((response) => {
                this.close.emit(true);
                this.uiService.message.showSuccess(
                    this.gfTranslateService.translate("Your board was successfully saved")
                );
            })
            .catch((err) => {
                this.errors = err.error;
                // let message = !_.isEmpty(this.errors)
                //     ? 'There were errors in your form, please review and submit again'
                //     : 'There was an unexpected error submitting your board';
                // this.uiService.message.showError(this.gfTranslateService.translate(message));
            });
    };

    toggleBoardShared() {
        this.board.isShared = (this.board.isShared == 'N') ? 'Y' : 'N';
    };

    setSelectedQuery(item) {
        this.board.config = {
            query: {
                id: item.id,
                queryName: item.name + ' (' + item.tracker.trackerName + ')',
                tracker: item.tracker.id
            },
            columnSource: {},
            rowSource: {},
            collapseEmpty: {
                columns: 0,
                rows: 0
            }
        };

        this.board.refId = this.board.config.query.id;
        return this.loadFields(item.tracker.id);
    }

    setSelectedSprint(sprint) {
        this.board.config = {
            sprint: {
                id: sprint.id,
                sprintName: sprint.name
            },
            columnSource: {},
            rowSource: {},
            collapseEmpty: {
                columns: 0,
                rows: 0
            }
        };

        this.board.refId = sprint.id;

        return this.loadFields();
    }

    setSelectedRelease(release) {
        this.board.config = {
            release: {
                id: release.id,
                sprintName: release.name
            },
            columnSource: {},
            rowSource: {},
            collapseEmpty: {
                columns: 0,
                rows: 0
            }
        };

        this.board.refId = release.id;

        return this.loadFields();
    }

    loadFields(trackerId: number = 0) {
        if (trackerId > 0) {
            return this.trackerRest.details(trackerId, { rel: 'fields,assignees' })
                .then((response) => {
                    const tracker = response;
                    this.fields = this.boardService.getSelectableFieldsFromTracker(tracker);
                })
                .catch((response) => {
                    console.log(response);
                });
        } else {
            //For multi-tracker cases, we only allow the basic fields
            this.fields = this.boardService.getSelectableIntrinsicFields();
        }
    }

    setSelected(field: any, section: string) {
        var currentSelected = _.find(this.fields, { alias: _.get(this.board, 'config.' + section + '.alias', null) });

        if (currentSelected) {
            currentSelected.selected = false;
        }

        field.selected = true;

        this.board.config[section] = {
            id: field.id,
            alias: field.alias,
            description: field.description,
            isExtraField: field.isExtraField
        };
    }

    mapQueriesToDrillDownOptions(queries: any) {
        if (!Array.isArray(queries)) return [];

        return _.map(queries, (tracker) => {
            return {
                section: 'tracker',
                id: tracker.id,
                name: tracker.trackerName,
                children: _.map(tracker.queries, (query) => {
                    return {
                        section: 'query',
                        id: query.id,
                        name: query.queryName,
                        tracker: query.tracker
                    };
                })
            }
        });
    }

    mapSprintsToDrillDownOptions(sprints: any) {
        if (!Array.isArray(sprints)) return [];

        return _.map(sprints, (sprint) => {
            return {
                id: sprint.id,
                name: sprint.sprintName
            }
        });
    }

    mapReleasesToDrillDownOptions(releases: any) {
        if (!Array.isArray(releases)) return [];

        return _.map(releases, (release) => {
            return {
                id: release.id,
                name: release.releaseName
            }
        });
    }

    findInTree(section, id, list, stack = []) {
        if (! id) {
            return false;
        }

        // If this list contains the requested item,
        // add it to the stack and return, we're done.
        const found = _.find(
            list,
            (candidate) => (candidate.section == section && candidate.id == id)
        );
        if (found) {
            return _.concat(stack, found);
        }

        // Is the requested item anywhere in this 
        // branch of the tree or its descendants?
        for (let idx = 0; idx < list?.length; idx++) {
            const child = list[idx];
            if (child.children?.length > 0) {
                const childStack = _.concat(stack, child);
                const ret = this.findInTree(section, id, child.children, childStack);
                if (ret && ret.length) {
                    return ret;
                }
            }
        }
        // It's not in this hierarchy of the source tree.
        return false;
    }

    getSelectedDataSourceLabel(stack = []) {
        if (!this.board.section || !stack?.length) {
            return 'Data Sources';
        }

        let title = _.last(stack).name;
        // TODO Change 1 to 2 when we add other sections
        if (stack.length > 2) {
            let parentTitle = _.first(stack.slice(-2, -1))?.name;
            title = `${ parentTitle }::${ title }`;
        }

        switch (this.board.section) {
            case 'query':
                return "Query: " + title;

            case 'sprint':
                return "Sprint: " + title;

            case 'release':
                return "Release: " + title;
        }
    }
};
